// modules/estrategias/habitante_calle/api/HabitanteCalleAPI.js
import axiosClient from "../../../inicio/api/axiosClient";

export const getPersonas = (params) => axiosClient.get("/habitante-calle", { params });
export const getPersonaById = (id) => axiosClient.get(`/habitante-calle/${id}`);
export const createPersona = (data) => axiosClient.post("/habitante-calle", data);
export const updatePersona = (id, data) => axiosClient.put(`/habitante-calle/${id}`, data);
export const deletePersona = (id) => axiosClient.delete(`/habitante-calle/${id}`);
export const exportarExcelHabitanteCalle = (params) => axiosClient.get("/habitante-calle/exportar", { params, responseType: "blob" });

export const subirConsentimientoHabitanteCalle = (id, archivo) => {
  const formData = new FormData();
  formData.append("archivo", archivo);
  return axiosClient.post(`/habitante-calle/${id}/consentimiento`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const eliminarConsentimientoHabitanteCalle = (id) => axiosClient.delete(`/habitante-calle/${id}/consentimiento`);

// Alias usados por offline/habitanteCalleOffline.js
export const crearPersonaAPI = createPersona;
export const actualizarPersonaAPI = updatePersona;
